export const detailsInformation = [
  {
    heading: ' Our Mission',
    text: `
       The world is in the constant process of adopting cloud technologies to solve
      business problems. This has especially been true of the online era COVID-19
      has triggered. 
      <br> 
       We aim to equip schools to leverage cloud-based technologies
      to not only make schools more efficient and better equipped, but to also
      strengthen their brand and reach.`,
      illustration:true,
      illustrationText:`
      You can think of Sclink as the medium between your school and the cloud.
      <br>
      Best illustrated in the picture above
      `
  },
  {
    heading: 'From the Founder',
    text: `
       My early professional career started with my job as a teacher at Learner's Academy.
       Through this I quickly realized that not just this school, but a lot of the schools
       in Mumbai and even in the country, weren't fully equipped with cloud technologies
       which are pretty much essential in today's day and age.
      <br> 
       So back in 2021 I started a new mission to solve this important problem and since 
       then have been working with schools in the locality to leverage cloud based solutions 
       to solve business problems and help deliver more value to not only the students but also the 
       employees of these schools.
       `,
  },
  {
    //must be last
    heading: ' Our Products',
    text: `
        Our products range from public webpages to strengthen branding, to intricate automated cloud infrastructure
        to future proof schools; all while making it secure and easy to use.
      <br>
        We offer different tiers of infrastructure based on our customers' needs all while understanding
        that everyone is different, and we actively work with our clients
        to find the perfect match for their needs.
      <br>
      <br>
        <div class="grid grid-cols-1 place-items-center">Some of our most popular tiers:</div>
    `,
    table:true
  },
]
